import React from "react";
import { Link } from "@amzn/awsui-components-react";
import { luscaSearchPath } from "./investigationUtils";

interface TransactionLinkProps {
  stage: string;
  transactionId?: string | null;
  orderId?: string | null;
}

/**
 * Human-readable identity for a DLQ item: its transaction ID (or order ID as a fallback) as a
 * link that opens the item in Lusca Search in a new tab. DLQ PKs are opaque, so every table or
 * summary that shows a PK should show this next to it. Renders "—" when neither ID is known.
 */
export const TransactionLink: React.FC<TransactionLinkProps> = ({
  stage,
  transactionId,
  orderId,
}) => {
  const id = transactionId || orderId;
  if (!id) return <>—</>;
  return (
    <Link
      href={luscaSearchPath(stage, id)}
      external
      ariaLabel={`Open ${id} in Lusca Search`}
    >
      <span style={{ wordBreak: "break-all" }}>{id}</span>
    </Link>
  );
};

export default TransactionLink;
